<template>
  <section class="webinar-contact">
    <v-container>
      <div class="row">
        <div class="col-12 col-sm-8 offset-sm-2">
          <rwl-heading h="2" align="center"  v-html="title"></rwl-heading>
          <p class="webinar-contact__description" v-html="description"></p>

<!--          <div class="row" style="display: none">-->
<!--            <div class="col-12">-->
<!--              <select-field name="subject"-->
<!--                            class="webinar-contact__subject"-->
<!--                            placeholder="Wybierz z listy"-->
<!--                            :options="subjectOptions"-->
<!--                            :label="$t('webinars.contact_subject')"-->
<!--                            :reduce="item => item.label"-->
<!--                            :v="$v.dataForm.subject"-->
<!--                            v-model="dataForm.subject"></select-field>-->
<!--            </div>-->
<!--          </div>-->

          <div class="row">
            <div class="col-12 col-sm-6">
              <input-field
                           name="fullName"
                           v-model="dataForm.fullName"
                           :label="$t('form.FormField_full_name')"
                           :v="$v.dataForm.fullName"></input-field>
            </div>
            <div class="col-12 col-sm-6">
              <input-field
                           name="email"
                           v-model="dataForm.email"
                           :label="$t('form.FormField_email')"
                           :v="$v.dataForm.email"></input-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6">
              <input-field
                           name="phone"
                           :label="$t('form.FormField_phone')"
                           v-model="dataForm.phone"
                           :v="$v.dataForm.phone"></input-field>
            </div>
            <div class="col-12 col-sm-6">
              <select-country-field class="select-field"
                                    name="country"
                                    :label="$t('form.FormField_country')"
                                    v-model="dataForm.country"
                                    :v="$v.dataForm.country"></select-country-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6">
              <input-field name="company"
                           :label="$t('form.FormField_company')"
                           v-model="dataForm.company"
                           :v="$v.dataForm.company">
              </input-field>
            </div>
            <div class="col-12 col-sm-6">
              <select-occupation-field class="select-field"
                                       name="occupation"
                                       :label="$t('form.FormField_occupation')"
                                       v-model="dataForm.occupation"
                                       :v="$v.dataForm.occupation">

              </select-occupation-field>
            </div>
          </div>

          <textarea-field
            :label="$t('form.FormField_message')"
            name="message"
            :v="$v.dataForm.message"
            v-model="dataForm.message"></textarea-field>

          <!-- CONSENTS -->
          <rwl-consents
            :application="$WEBINARS.forms.contactForm.application"
            :category="$WEBINARS.forms.contactForm.categoryID"
            class="mt-3"
            ref="consents"
            :validate="$v.$dirty"
            :language="$i18n.locale"
            :dirty="$v.$dirty"
            @onValidation="onConsentsValidation"
          ></rwl-consents>
          <!-- CONSENTS -->

          <div class="col-12 form-alerts">
            <rwl-alert
              danger
              v-if="$v.$anyError || ($v.$dirty || consentStatus === false) && status==='INVALID_FIELDS'"
            >
              {{$t('form.FormMessage_error_invalid_fields')}}
            </rwl-alert>
            <rwl-alert danger v-else-if="error && errorMessage">
              {{errorMessage}}
            </rwl-alert>
            <rwl-alert info class="statement-processing" v-if="status==='PROCESSING'">
              <span>{{$t('form.FormMessage_processing')}}</span>
            </rwl-alert>
            <rwl-alert success v-if="status==='SUCCESS'">
              <span>{{$t('form.success')}}</span>
            </rwl-alert>
          </div>

          <rwl-button
            primary
            center
            @click="onSubmit"
            class="form-submit"
            v-html="$t('webinars.contact_button')"
          >
          </rwl-button>

        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
  import axios from 'axios';
  import {
    RwlHeading,
    RwlSelect,
    RwlLabel,
    RwlTextarea,
    RwlButton,
    RwlAlert,
    InputField,
    SelectCountryField,
    SelectOccupationField,
    TextareaField,
    RwlConsents
  } from "@rawlplug/rawlplug-design-components-library";

  import {
    getErrorByStatus,
    getErrorByType,
    ErrorTypes,
  } from "@rawlplug/rawlplug-events-calendar";

  import { validationMixin } from 'vuelidate'
  import { required, email } from "vuelidate/lib/validators"

  const initialDataForm = {
    subject: "",
    fullName: "",
    email: "",
    phone: "",
    country: "",
    company: "",
    occupation: "",
    message: ""
  }

  export default {
    name: "WebinarCalendar",
    mixins: [validationMixin],
    components: {
      RwlHeading,
      TextareaField,
      RwlButton,
      SelectCountryField,
      SelectOccupationField,
      RwlConsents,
      InputField,
      RwlAlert
    },
    props: {
      title: {
        type: String,
      },
      description: {
        type: String,
      }
    },
    data() {
      return {
        dataForm: initialDataForm,
        status: null,
        consentStatus: null,
        error: null,
        errorMessage: ''
      }
    },
    validations: {
      dataForm: {
        fullName: { required },
        email: { required, email },
        phone: { required },
        country: { required },
        company: { required },
        occupation: {},
        message: { required },
      }
    },
    computed: {
      formClasses() {
        return {
          "event-form": true,
          "processing": this.status === "PROCESSING"
        }
      },
    },
    methods: {
      async onSubmit(ev) {
        ev.preventDefault();
        this.$v.$touch();
        if (!this.$refs.consents.isConsentsValid() || this.$v.$invalid) {
          this.status = "INVALID_FIELDS";
          return;
        }
        this.status = "PROCESSING";

        try {
          await this.send();
          this.errorMessage = null;
          this.error = null;
          this.status = 'SUCCESS';
          this.reset();
        } catch (e) {
          let error;

          if (e.response) {
            if (e.response.status) {
              error = getErrorByStatus(e.response.status);
              error.message = this.$t(error.term);
              error.status = e.response.status;
            } else {
              error = getErrorByType(ErrorTypes.DEFAULT);
              error.message = this.$t(error.term);
            }
          } else {
            error = getErrorByType(ErrorTypes.DEFAULT);
            error.message = this.$t(error.term);
          }

          this.error = error;
          this.errorMessage = error.message;
          this.status = "ERROR";
        }
      },
      async send() {
        let consentsValues = this.$refs.consents.getMappedSelectedConsents();
        let { subject, fullName, email, phone, company, country, occupation, message } = this.dataForm;
        const requestType = "ra-webinar";

        const dataModel = {
          subject,
          requestType,
          email,
          country,
          fullName,
          message,
          company,
          occupation: occupation ? occupation : "",
          phone,
          consents: JSON.stringify(consentsValues),
          language: this.$WEBINARS.settings.getLanguage(),
          form: {
            code: "webinars",
            name: "Webinars - Contact form",
          }
        }

        return await axios.put(this.$WEBINARS.config.contactFormAPI, dataModel);
      },
      reset() {
        this.dataForm = initialDataForm;
        this.$v.$reset();
      },
      onConsentsValidation(value) {
        this.consentStatus = value;
      },
      jumpToFirstError() {
        let formField = this.$el.querySelector('.has-error');
        if (formField) {
          let elemTop = formField.getBoundingClientRect().top;
          let scrollTop = window.pageYOffset;
          let top = scrollTop + elemTop - 120;

          scrollTo(top);
        }
      },
    }
  }
</script>

<style lang="scss">
  .select-field .vs__dropdown-toggle {
    background-color: $color-rwl-white-100;
  }

  .webinar-contact {
    .input-field {
      label {
        display: block;
        color: #858585;
        margin-bottom: $spacing-3;
      }
    }

    .select-field .vs__dropdown-toggle {
      background-color: #fff;
    }

    .webinar-contact__subject {
      margin-bottom: $spacing-5;
    }

    textarea.rwl-textarea {
      background-color: #fff;
    }
  }
</style>

<style lang="scss" scoped>
  @import "~@rawlplug/rawlplug-design-style-framework/src/scss/rawlplug";

  .webinar-contact {
    background: url("#{$assetsPath}images/contact_background.jpg");
    background-position: center;
    background-size: cover;
    padding: $section-padding;
    font-size: 16px;

    &__description {
      color: $color-text;
      margin-bottom: $spacing-6;
      line-height: $line-height-base;
    }

    .rwl-button.form-submit {
      display: block;
      margin: $spacing-5 auto;
    }
  }


  .form-alerts {
    margin-top: $spacing-5;
  }


</style>
